import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, AccessGuard } from '../auth/_guards';

const routes: Routes = [
    {
        'path': 'admin',
        'component': ThemeComponent,
        'canActivate': [AuthGuard],
        'children': [
            //dashboard
            {
                'path': 'index',
                'loadChildren': '.\/pages\/admin\/appt\/dashboard.module#AdminDashboardModule',
            },
            {
                'path': 'dashboard',
                'loadChildren': '.\/pages\/admin\/appt\/dashboard.module#AdminDashboardModule',
            },
            {
                'path': 'mdashboard',
                'loadChildren': '.\/pages\/admin\/appt\/dashboard-mobile.module#AdminDashboardMobileModule',
            },
            //appt
            {
                'path': 'appt',
                'loadChildren': '.\/pages\/admin\/appt\/appt-search.module#ApptSearchModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'appointment', key: ['view'] } }
            },
            {
                'path': 'appt/pending',
                'loadChildren': '.\/pages\/admin\/appt\/appt-pending.module#ApptPendingModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'appointment', key: ['view'] } }
            },
            {
                'path': 'appt/view',
                'loadChildren': '.\/pages\/admin\/appt\/appt-edit.module#ApptEditModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'appointment', key: ['view'] } }
            },
            //custom text
            {
                'path': 'setup/text',
                'loadChildren': '.\/pages\/admin\/setup\/text\/setup-text.module#SetupTextModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'custom_text', key: ['edit'] } }
            },
            //user
            {
                'path': 'setup/user',
                'loadChildren': '.\/pages\/admin\/setup\/user\/user-list.module#UserListModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'admin_user', key: ['view'] } }
            },
            {
                'path': 'setup/user/new',
                'loadChildren': '.\/pages\/admin\/setup\/user\/user-new.module#UserNewModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'admin_user', key: ['add'] } }
            },
            {
                'path': 'setup/user/edit',
                'loadChildren': '.\/pages\/admin\/setup\/user\/user-edit.module#UserEditModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'admin_user', key: ['view'] } }
            },
            //form
            {
                'path': 'setup/form',
                'loadChildren': '.\/pages\/admin\/setup\/form\/form-setup.module#FormSetupModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'customer_data', key: ['view'] } }
            },
            //holiday
            {
                'path': 'setup/holiday',
                'loadChildren': '.\/pages\/admin\/setup\/holiday\/holiday.module#HolidayModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'holiday', key: ['view'] } }
            },
            //location
            {
                'path': 'setup/location',
                'loadChildren': '.\/pages\/admin\/setup\/location\/loc-list.module#LocListModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'location', key: ['view'] } }
            },
            {
                'path': 'setup/location/new',
                'loadChildren': '.\/pages\/admin\/setup\/location\/loc-new.module#LocNewModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'location', key: ['add'] } }
            },
            {
                'path': 'setup/location/edit',
                'loadChildren': '.\/pages\/admin\/setup\/location\/loc-edit.module#LocEditModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'location', key: ['edit'] } }
            },
            //location group
            {
                'path': 'setup/location/group',
                'loadChildren': '.\/pages\/admin\/setup\/location-group\/loc-group-list.module#LocGroupListModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'location_group', key: ['view'] } }
            },
            {
                'path': 'setup/location/group/new',
                'loadChildren': '.\/pages\/admin\/setup\/location-group\/loc-group-new.module#LocGroupNewModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'location_group', key: ['add'] } }
            },
            {
                'path': 'setup/location/group/edit',
                'loadChildren': '.\/pages\/admin\/setup\/location-group\/loc-group-edit.module#LocGroupEditModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'location_group', key: ['edit'] } }
            },
            //package
            {
                'path': 'setup/package',
                'loadChildren': '.\/pages\/admin\/setup\/package\/package-list.module#PackageListModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'package', key: ['view'] } }
            },
            {
                'path': 'setup/package/new',
                'loadChildren': '.\/pages\/admin\/setup\/package\/package-new.module#PackageNewModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'package', key: ['add'] } }
            },
            {
                'path': 'setup/package/edit',
                'loadChildren': '.\/pages\/admin\/setup\/package\/package-edit.module#PackageEditModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'package', key: ['edit'] } }
            },
            {
                'path': 'setup/packagetype',
                'loadChildren': '.\/pages\/admin\/setup\/package-type\/package-type-list.module#PackageTypeListModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'package', key: ['view'] } }
            },
            {
                'path': 'setup/packagetype/new',
                'loadChildren': '.\/pages\/admin\/setup\/package-type\/package-type-new.module#PackageTypeNewModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'package', key: ['add'] } }
            },
            {
                'path': 'setup/packagetype/edit',
                'loadChildren': '.\/pages\/admin\/setup\/package-type\/package-type-edit.module#PackageTypeEditModule',
                'canLoad': [AccessGuard],
                'data': { access: { action_id: 'package', key: ['edit'] } }
            },
            {
                'path': '',
                'redirectTo': 'index',
                'pathMatch': 'full',
            },
        ],
    },
    {
        'path': 'user',
        'component': ThemeComponent,
        'canActivate': [AuthGuard],
        'children': [
            {
                'path': 'index',
                'loadChildren': '.\/pages\/user\/appt\/dashboard.module#UserDashboardModule',
            },
            {
                'path': 'dashboard',
                'loadChildren': '.\/pages\/user\/appt\/dashboard.module#UserDashboardModule',
            },
            {
                'path': 'profile',
                'loadChildren': '.\/pages\/user\/profile\/profile.module#UserProfileModule',
            },
            {
                'path': 'appt/view',
                'loadChildren': '.\/pages\/user\/appt\/appt-view.module#UserApptModule',
            },
            {
                'path': '',
                'redirectTo': 'index',
                'pathMatch': 'full',
            }
        ]
    },
    {
        'path': '',
        'component': ThemeComponent,
        // 'canActivate': [AuthGuard],
        'children': [
            {
                'path': 'index',
                // 'loadChildren': '.\/pages\/default\/blank\/blank.module#BlankModule',
                'loadChildren': '.\/pages\/default\/appt\/homepage.module#ApptHomeModule',
            },
            {
                'path': 'appt',
                'loadChildren': '.\/pages\/default\/appt\/appt-new.module#ApptNewModule',
            },
            {
                'path': '',
                'redirectTo': 'index',
                'pathMatch': 'full',
            },
        ],
    },
    {
        'path': '**',
        'redirectTo': 'index',
        'pathMatch': 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    // providers: [CanLoadModule]
})
export class ThemeRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts